export default {
  'menu.welcome': '欢迎',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.merchant': '商家管理',
  'menu.merchant.info': '商家信息管理',
  'menu.merchant.audit': '商家审核管理',
  'menu.merchant.create': '新增商家',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.role': '角色管理',
  'menu.system.user': '用户管理',
  'menu.taskManagement': '任务管理',
  'menu.taskManagement.list': '任务发布',
  'menu.taskManagement.detail': '任务详情',
  'menu.taskManagement.create': '创建任务',
  'menu.taskManagement.createArticle': '创建图文任务',
  'menu.taskManagement.createVideo': '创建视频任务',
  'menu.taskManagement.createMoments': '创建朋友圈任务',
  'menu.taskManagement.editTask': '编辑任务',
  'menu.taskManagement.taskProgress': '任务完成情况',
  'menu.taskManagement.publishedList': '任务管理',
  'menu.taskManagement.waitReviewList': '任务审核',
  'menu.taskManagement.userTaskList': '个人任务管理',
  'menu.recharge': '账户充值',
  'menu.rechargeHistory': '充值记录',
  'menu.rechargeSuccess': '充值成功',
  'menu.bill': '账单管理',
  'menu.bill.list': '账单详情',
  'menu.userManagement': '客户管理',
};